import { render, staticRenderFns } from "./taskrecord copy.vue?vue&type=template&id=3709ac63&"
import script from "./taskrecord copy.vue?vue&type=script&lang=js&"
export * from "./taskrecord copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports